import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useAuth, resolveOnboardingPath } from "../../../contexts/AuthContext";
import { authService } from "../../../services/auth.service";
import styles from "../../../styles/pages/auth/LoginScreen.module.css";

export default function ConfirmEmailPage() {
  const navigate = useNavigate();
  const { uid, token } = useParams();
  const { loginWithTokens } = useAuth();

  const [status, setStatus] = useState("loading"); // loading | error
  const [errorMessage, setErrorMessage] = useState("");
  // Deduplica por (uid, token): evita la doble corrida (StrictMode) pero permite
  // re-procesar si el usuario abre otro link de confirmación sin desmontar.
  const lastRunKeyRef = useRef("");

  useEffect(() => {
    const runKey = `${uid || ""}:${token || ""}`;
    if (lastRunKeyRef.current === runKey) return;
    lastRunKeyRef.current = runKey;

    (async () => {
      try {
        const data = await authService.confirmEmail({ uid, token });

        if (data?.code === "EMAIL_CONFIRMED" && data?.access && data?.refresh) {
          const nextAuth = await loginWithTokens({
            access: data.access,
            refresh: data.refresh,
          });
          navigate(resolveOnboardingPath(nextAuth) || "/dashboard", {
            replace: true,
          });
          return;
        }

        // ALREADY_VERIFIED u otra respuesta sin tokens: el link ya se usó.
        navigate("/login", { replace: true });
      } catch (error) {
        const code = error?.response?.data?.code;
        setErrorMessage(
          code === "INVALID_OR_EXPIRED_TOKEN"
            ? "El enlace de confirmación es inválido o expiró."
            : "No se pudo confirmar tu correo. Intentá nuevamente.",
        );
        setStatus("error");
        console.error(error?.response?.data || error);
      }
    })();
  }, [uid, token, loginWithTokens, navigate]);

  return (
    <div className={styles.login}>
      <div className={styles.leftLogin} />

      <div className={styles.rightLogin}>
        <div className={styles.successContainer}>
          {status === "loading" ? (
            <h1 className={styles.successTitle}>Confirmando tu correo...</h1>
          ) : (
            <>
              <h1 className={styles.successTitle}>No pudimos confirmar tu correo</h1>
              <div className={styles.successInfoBox}>{errorMessage}</div>
              <div className={styles.divider} />
              <p className={styles.resendText}>
                <button
                  type="button"
                  className={styles.resendLink}
                  onClick={() => navigate("/login")}
                >
                  Volver a iniciar sesión
                </button>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
